import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const getUserProfileItemsOwned = async ({ uid }) => {
	try {
		const userProfileDocRef = firestore.collection('userProfiles').doc(uid)

		const itemsOwnedQuerySnap = await userProfileDocRef.collection('itemsOwned')
			.orderBy('createdTimestamp', 'desc')
			.get()


		return itemsOwnedQuerySnap.docs.map(d => d.data())
	} catch (error) {
		throw errorOfType(errorTypes.UNKNOWNERROR, uid, error)
	}
}

export default getUserProfileItemsOwned



// WEBPACK FOOTER //
// ./src/dataservices/getUserProfileItemsOwned.js